import React from 'react';
import cx from 'classnames';
import { isValidLogo, getIntegrationEntryConfig } from '../../helpers/logo-map';
import stylesheet from './index.css';
import { useColorScheme } from './../../helpers/utils-ts';

export type CoinProps =
  | {
      fallbackImage?: string;
      imageKey: string;
      label?: string;
    }
  | {
      children: React.ReactNode;
      label: string;
    };

/**
 * Retrieves the configuration entry for a given integration key.
 *
 * @param {string} integration - The key representing the integration.
 * @returns {Object} The configuration object containing the label and image URL for the specified integration.
 */

const Coin: React.FC<CoinProps> = (props) => {
  const colorScheme = useColorScheme();

  if ('children' in props && React.isValidElement(props.children)) {
    return <li className={cx(stylesheet.coin)}>{props.children}</li>;
  }

  if ('imageKey' in props && isValidLogo(props.imageKey)) {
    const image = props.imageKey;
    const logo = getIntegrationEntryConfig(image);
    return (
      <li className={cx(stylesheet.coin)}>
        <img
          src={
            colorScheme === 'dark'
              ? logo?.image.dark ?? logo?.image.light
              : logo?.image.light
          }
          alt={logo.label}
        />
      </li>
    );
  }

  const fallbackImage =
    'fallbackImage' in props && props.fallbackImage
      ? props.fallbackImage
      : 'mailchimp';

  // If the image is not valid, we are going to render the fallback image
  return <Coin imageKey={fallbackImage} />;
};

export default Coin;
